// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  apiRoot: "https://muralmigrationtoolapi.azurewebsites.net/",   
  GetAgentAPICall:"GetAgent",
  download64bit: "https://conciergedemodownload.blob.core.windows.net/conciergedemodownloads/Concierge.exe",
  download32bit: "https://conciergedemodownload.blob.core.windows.net/conciergedemodownloads/Concierge.exe",
  downloadMsi: "https://conciergedemodownload.blob.core.windows.net/conciergedemodownloads/Concierge.msi", 
  firebaseConfig : {

    apiKey: "AIzaSyAl6VLklTvHtwqT5dBzKSmqef4B29wx4MY",
    authDomain: "conciergedemoapi.firebaseapp.com",
    databaseURL: "https://conciergedemoapi.firebaseio.com",
    projectId: "conciergedemoapi",
    storageBucket: "conciergedemoapi.appspot.com",
    messagingSenderId: "735450958456"


   }



   /**
    * 
    */
};



// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/environments/environment.ts